export default function checkTween(tweens, id) {
  if (tweens && tweens[id]) tweens[id].kill()
}
